import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";
import ProductBanner from "@/component/product-banner";
import FaqsCompo from "@/component/faqs";
import RecomCharacteristics from "@/component/recom-characteristics";
import ImageStepsCard from "@/component/image-steps-card";
import TVCard from "@/component/tv-card";

const filePath = "layout/fichas.js";
const Devices = dynamic(() => import("@/component/devices-offers-bf"));
const ImageClusertInfoModule = dynamic(() =>
  import("@/bit/components/next13.components.image-cluster-info-module")
);

/**
 * @name Layout
 * @description Connectivity page layout
 * @param {any} props
 * @returns {React.FC}
 */

export default function Layout(props) {
  const { productName, alias } = props;
  const [devicesData, setdevicesData] = useState(null);
  const { context } = useSelector((state) => state.main);

  useEffect(() => {
    // Ficha BF componente custo
    const fetchData = async () => {
      if (
        props["COMPONENT_TYPE"] &&
        props["COMPONENT_TYPE"].creativityId === "CMS-GP-OFERTAS-DISPOSITIVOS-CONVERGENTE"
      ) {
        try {
          const module = await import("@gerenciatd/next13.adabyron.custo.get-by-name");
          const getByName = module.default;
          const custoInfo = await getByName({
            name: "CMS-GP-OFERTAS-DISPOSITIVOS-CONVERGENTE",
            context,
            build: false,
            kind: "activity",
          });
          setdevicesData(custoInfo);
        } catch (error) {
          // Handle any errors that might occur during the fetching process
          console.error(error);
        }
      }
    };
    fetchData();
  }, []);
  return (
    <>
      {props["MODULO_BUYBOX"] && props["MODULO_CARACTERISTIC_CARDS"] && (
        <ProductBanner
          productName={productName}
          orionTitle={props["MODULO_H1"]}
          orionBanner={props["MODULO_BANNER"]}
          orionBuyBox={props["MODULO_BUYBOX"]}
          orionSelector={props["MODULO_SELECTOR"]}
          orionCharacs={props["MODULO_CARACTERISTIC_CARDS"]}
          orionImageSlider={props["MODULE_SECTION_IMAGE_SLIDER"]}
          simphePhoneFicha={props["MODULO_SIMPLEPHONE_FICHA"]}
          alias={alias}
        />
      )}

      {devicesData && <Devices {...devicesData} />}

      {props["MODULO_RECOMENDACION"] && <RecomCharacteristics {...props["MODULO_RECOMENDACION"]} />}

      {props["MODULO_PACK_CARD"] && (
        <TVCard {...props["MODULO_PACK_CARD"]} module="MODULO_PACK_CARD" />
      )}

      {props["MODULO_SIMPLE_CARD"] && (
        <TVCard {...props["MODULO_SIMPLE_CARD"]} module="MODULO_SIMPLE_CARD" />
      )}

      {props && props["MODULE_DESCRIPTION_IMG"] && (
        <ImageStepsCard {...props["MODULE_DESCRIPTION_IMG"]} />
      )}

      {alias === "movistarplus" && props["MODULO_LISTADO_CONTENIDOS_IMAGENES_EXTRA"] && (
        <ImageClusertInfoModule {...props["MODULO_LISTADO_CONTENIDOS_IMAGENES_EXTRA"]} />
      )}
      {props && props["FAQS_PREGUNTAS_FRECUENTES"] && (
        <FaqsCompo {...props["FAQS_PREGUNTAS_FRECUENTES"]} />
      )}
    </>
  );
}
